import isServer from '@framework/router/Next/isServer';

// Check if it's possible to use internal network
export const shouldUseInternalNetwork = (): boolean => isServer() && process.env.USE_EXTERNAL_NETWORK === '0';
export default shouldUseInternalNetwork;
